const hideExpDate = () => {
    $('#generic-error-message').remove();
    $('#expirationDateGroup').removeClass('has-month-error');
    $('.form-group.card-expire-month').removeClass('has-error').find('#card-expire-month-error-message').remove();

    $('#generic-error-message').remove();
    $('#expirationDateGroup').removeClass('has-year-error');
    $('.form-group.card-expire-year').removeClass('has-error').find('#card-expire-year-error-message').remove();

    $('#expirationDateGroup').hide();
};

const showExpDate = () => {
    $('#expirationDateGroup').show();
};

export {
    hideExpDate,
    showExpDate
}
